module.exports = __webpack_public_path__ + "img/index04.3d768df1.jpg";